// extracted by mini-css-extract-plugin
var _1 = "_inventoryTransactionSearchAndFilterBar-module__content-container";
export { _1 as "content-container" }
